module.exports = __webpack_public_path__ + "media/images/athletes/1489-c6fd0ce42e93a71b4296fddd28e8884c.png";